import React from "react";
export const DefaultLoader = (props)=>(
    <div className={"flex flex-col text-2xl items-center"}>
        <div className={"mt-10"}>{props.text}</div>
    </div>
)